<template>
  <nav v-if="currentIndex >= 0" class="wizard-progress" :aria-label="$t('Avanzamento del wizard')">
    <p class="wizard-progress-compact" :class="{ 'pf-v6-u-display-none-on-lg': !wizard.modal }">
      {{ $t('Passo {0} di {1}', [currentIndex + 1, wizard.progressSteps.length]) }}
    </p>

    <div v-if="!wizard.modal" class="pf-v6-u-display-none pf-v6-u-display-block-on-lg">
      <pf-progress-stepper ouia-id="wizard-progress">
        <pf-progress-step
          v-for="(step, i) in wizard.progressSteps"
          :key="step"
          :variant="i < currentIndex ? 'success' : i === currentIndex ? 'info' : 'pending'"
          :current="i === currentIndex"
          :ouia-id="`wizard-progress-${step}`"
        >
          <pf-button v-if="i < currentIndex" variant="link" inline @click="wizard.currentStep = step">
            {{ label(step) }}
          </pf-button>
          <template v-else>{{ label(step) }}</template>
        </pf-progress-step>
      </pf-progress-stepper>
    </div>
  </nav>
</template>

<style scoped>
.wizard-progress {
  margin-block-end: var(--pf-t--global--spacer--lg);
}

.wizard-progress-compact {
  font-size: var(--pf-t--global--font--size--sm);
  color: var(--pf-t--global--text--color--subtle);
}
</style>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { computed } from 'vue';
import { useWizard } from '@/wizard';

const wizard = useWizard();

const labels: Record<string, string> = {
  WizardStepClienti: _t('Intestazione'),
  WizardStepScopo: _t('Scopo'),
  WizardStepDominio: _t('Dominio'),
  WizardStepProdottiInfrastruttura: _t('Prodotto'),
  WizardStepStack: _t('Stack'),
  WizardStepConfigurazione: _t('Configurazione'),
  WizardStepTrasferimenti: _t('Trasferimento'),
  WizardStepLocation: _t('Location'),
  WizardStepAddon: _t('Servizi aggiuntivi'),
  WizardStepAdd: _t('Riepilogo prodotti'),
  WizardStepSummary: _t('Offerta'),
};

function label(step: string) {
  return labels[step] ?? step;
}

const currentIndex = computed(() => wizard.progressSteps.indexOf(wizard.currentStep));
</script>
